module.exports = __webpack_public_path__ + "static/media/pyv-auto-tracking-complete-and-review.45870652.gif";